<template>
  <v-container fluid>
    <v-row class="cards" no-gutters>
      <v-col cols="12">
        <v-text-field
          v-model="productName"
          label="Cari Produk"
          outlined
          prepend-inner-icon="mdi-magnify"
          clearable
          @keydown.enter="searchProduct()"
          class="ma-0 pa-0"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <div class="points">
          <div
          class="d-flex justify-space-between align-center">
            <p class="ma-0 pa-0  font-weight-bold">Filter</p>
            <div>
              <v-icon @click="loadDialogFilter">mdi-chevron-right</v-icon>
            </div>
          </div>
          <div >
            <div v-if="productPartnerRequestList.length" class="d-flex flex-wrap flex-row">
              <v-chip
                class="ma-2"
                 v-for="(item, index) in productPartnerRequestList" :key="item"
                close
                @click:close="removeChipFilter(index)"
              >
                {{ item }}
              </v-chip>
            </div>
            <div v-if="sort != ''">
              <v-chip
                class="ma-2"
                close
                @click:close="removeChipSorting"
              >
                {{ sort == 'ASC' ? 'Ascending (A-Z)' : 'Descending (Z-A)'}}
              </v-chip>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" class="mt-3">
        <div class="d-flex flex-row flex-wrap containerCards">
          <div
            v-for="product in this.products"
            :key="product.productCode"
            class="mb-2"
          >
            <router-link
              v-if="mode == $constant.NON_REWARD"
              :to="`/product/${product.productCode}/${$constant.NON_REWARD}/detail`"
              class="text-decoration-none"
            >
              <Card :product="product" :poin="poin"></Card>
            </router-link>
            <router-link
              v-else
              :to="`/product/${product.productCode}/${$constant.REWARD}/detail`"
              class="text-decoration-none"
            >
              <Card :product="product" :poin="poin"></Card>
            </router-link>
          </div>
        </div>
        <div v-if="this.showLoadMore">
          <button class="btnLoad" @click="nextPage">
            Load More
          </button>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-dialog
          v-model="showDrawerFilter"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="showDrawerFilter = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Filter</v-toolbar-title>
              <!-- <v-spacer></v-spacer>
              <v-toolbar-items>
                
              </v-toolbar-items> -->
            </v-toolbar>
            <v-row>
              <v-col cols="6">
                <div class="container-filter d-flex flex-wrap justify-space-between">
                  <p class="font-weight-bold mb-3">Brand</p>
                  <div v-for="(partner, index) in partnerList" :key="index">
                    <v-checkbox
                      v-model="productPartnerRequestList"
                      :label="partner.productPartnerName"
                      :value="partner.productPartnerName"
                    ></v-checkbox>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="container-filter">
                  <p class="font-weight-bold mb-3">Sort Nama Produk</p>
                  <v-radio-group
                    v-model="sort"
                    column
                  >
                    <v-radio
                      color="primary"
                      label="Descending (Z-A)"
                      value="DESC"
                    ></v-radio>
                    <v-radio
                      color="primary"
                      label="Ascending (A-Z)"
                      value="ASC"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn
                  @click="searchFilter"
                  :disabled="productPartnerRequestList.length < 1 && sort == ''"
                  class="mr-4"
                  color="primary"
                >
                  CARI
                </v-btn>
                <v-btn
                  @click="clearFilter"
                  :disabled="productPartnerRequestList.length < 1 && sort == ''"
                  color="primary"
                >
                  CLEAR
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Card from '@/components/Card/Card.vue'

export default {
  name: "Products",
  props: ['mode'],
  data() {
    return {
      productName: "",
      loading: false,
      pageSize: 12,
      pageNumber: 1,
      products: [],
      showLoadMore: false,
      poin: false,
      showDrawerFilter: false,
      productPartnerRequestList: [],
      sort: '',
      selected: [],
      selectedProductName: [],
      partnerList: [],
    };
  },
  components: {
    Card,
  },
  methods: {
    ...mapActions(["changeTitleApp", "getProducts","getListProductReward","getPartner"]),
    nextPage() {
      this.pageNumber = this.pageNumber + 1;

      if (this.mode == this.$constant.NON_REWARD) {
        this.getProducts({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          productName: this.productName,
          productPartnerRequestList: this.productPartnerRequestList,
          sort: this.sort
        })
        .then((response) => {
          this.products.push.apply(this.products, response.data.data.content);

          if ((this.products.length >= response.data.data.totalElements) 
        || (response.data.data.content.length < 1)) {
            this.showLoadMore = false;
            this.pageNumber = 1;
          }
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
      } else {
        this.getListProductReward({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          productName: this.productName,
          productPartnerRequestList: this.productPartnerRequestList,
          sort: this.sort
        })
        .then((response) => {
          this.products.push.apply(this.products, response.data.data.content);

          if ((this.products.length >= response.data.data.totalElements) 
        || (response.data.data.content.length < 1)) {
            this.showLoadMore = false;
            this.pageNumber = 1;
          }
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
      }

    },

    async searchProduct() {
      this.pageNumber = 1;
      this.products = [];

      if (this.mode == this.$constant.NON_REWARD) {
        await this.getProducts({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          productName: this.productName,
          productPartnerRequestList: this.productPartnerRequestList,
          sort: this.sort,
        })
          .then((response) => {
            this.products = response.data.data.content;
            this.showLoadMore =
              this.products.length < response.data.data.totalElements ? true : false;
          })
          .catch((error) => {
            this.$helpers.handleError(error);
          });
      } else {
        await this.getListProductReward({
          pageSize: this.pageSize,
          pageNumber: 1,
          productName: this.productName,
          productPartnerRequestList: this.productPartnerRequestList,
          sort: this.sort,
        })
        .then((response) => {
            this.products = response.data.data.content;
            this.showLoadMore =
              this.products.length < response.data.data.totalElements ? true : false;
          })
          .catch((error) => {
            this.$helpers.handleError(error);
          });
      }
    
    },
    async loadProducts() {
      //load produtcs
      await this.getProducts({
        pageSize: this.pageSize,
        pageNumber: 1,
        productName: "",
        productPartnerRequestList: this.productPartnerRequestList,
        sort: this.sort,
      })
        .then((response) => {
          this.products = response.data.data.content;

          this.showLoadMore =
            this.products.length < response.data.data.totalElements ? true : false;
          return this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },
    async loadProductsReward() {
      //load produtcs
      await this.getListProductReward({
        pageSize: this.pageSize,
        pageNumber: 1,
        productName: "",
        productPartnerRequestList: this.productPartnerRequestList,
        sort: this.sort,
      })
      .then((response) => {
          this.products = response.data.data.content;

          this.showLoadMore =
            this.products.length < response.data.data.totalElements ? true : false;
          return this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },

    loadDialogFilter(){
      this.getPartner({
        pageNumber: 1,
        pageSize: 200
      })
      .then((response) => {
        console.log(response)
        this.partnerList = response.data.data.listData;
        this.showDrawerFilter = true;
      })
    },
    searchFilter(){
      this.showDrawerFilter = false;
      this.searchProduct();
    },
    clearFilter(){
      this.selectedProductName = [];
      this.productPartnerRequestList = [];
      this.showDrawerFilter = false;
      this.searchProduct();
    },
    removeChipFilter(index){
      this.productPartnerRequestList.splice(index, 1);

      this.searchProduct();
    },
    removeChipSorting(){
      this.sort = '';

      this.searchProduct();
    }
  },
  created() {
    this.changeTitleApp("Produk");
  },
  mounted() {
    if (this.mode == this.$constant.NON_REWARD) {
      this.poin = false;
      this.loadProducts();
    } else {
      this.poin = true;
      this.loadProductsReward();
    }
    
  },
  computed: {
    // ...mapState(["products"]),
  },
};
</script>

// <style src="./Products.scss" lang="scss" />
